import React, { Component } from "react"
import { withActions } from "../../utils"
import { toastr } from "react-redux-toastr"
import { connect } from "react-redux"
import Hidable from "../Hidable"
import Card from "../Card"
import SimpleTable from "../SimpleTable"
import Button from "react-toolbox/lib/button"
import * as utils from "../../utils"
import * as strings from "../../strings"
import ExpenseDialog from "./ExpenseDialog"
import styles from "./styles.css"
import _ from "lodash"
import download from "downloadjs"

const TABLE_COLUMNS = {
  expenseType: {
    title: strings.management.expenseType,
    align: "left",
  },
  value: {
    title: strings.generalStrings.value,
    align: "right",
  },
  documentNumber: {
    title: strings.generalStrings.documentNumber,
    align: "right",
  },
  details: {
    title: strings.generalStrings.details,
  },
  expenseDate: {
    title: strings.generalStrings.date,
    align: "right",
  },
  internalInvoiceNumber: {
    title: strings.invoices.internalInvoiceNumber,
    align: "right",
  },
  internalInvoiceDate: {
    title: strings.invoices.invoiceDate,
    align: "right",
  },
}

class DebtPhaseExpenses extends Component {
  props: {
    expenses: any[],
    onChange: () => {},
    actions: any,
    idLitigation: number,
  }

  state = {
    createFormVisible: false,
    editingExpense: undefined,
  }

  updateExpense = value => {
    this.props.actions.updateExpense( value )
      .then( res => {
        if ( res.message === "OK" ) {
          this.props.onChange( this.props.expenses.map( expense => {
            if ( expense.id === res.result.id ) {
              return res.result
            } else {
              return expense
            }
          } ) )
        }
      } )
      .then( () => this.hideForms() )
      .catch( () => toastr.error( strings.expenses.errorUpdatingExpense ) )
  }

  downloadExpenseDocument = async values => {
    if ( !values.id ) {
      return
    }

    this.props.actions.getExpenseReceipt( values.id )
      .then( file => download( file, values.receiptFileName ) )
      .catch( () => toastr.error( strings.expenses.errorGettingExpenseReceipt ) )
  }

  deleteExpense = values => {
    this.props.actions.removeExpense( values.id )
      .then( res => {
        if ( res.message === "OK" ) {
          this.props.onChange( _.filter( this.props.expenses, e => e.id !== values.id ) )
        }
      } )
      .then( () => this.hideForms() )
      .catch( () => toastr.error( strings.expenses.errorDeletingExpense ) )
  }

  createExpense = values => {
    this.props.actions.createExpense( {
      ...values,
      idLitigation: this.props.idLitigation,
    } )
      .then( res => {
        if ( res.message === "OK" ) {
          this.props.onChange( [
            ...this.props.expenses,
            res.result,
          ] )
        }
      } )
      .then( () => this.hideForms() )
      .catch( () => toastr.error( strings.expenses.errorAddingExpense ) )
  }

  hideForms = () => this.setState( {
    createFormVisible: false,
    editingExpense: undefined,
  } )

  editExpense = id => () => this.setState( {
    editingExpense: id,
  } )

  prepareExpenses = expenses => expenses.map( expense => {
    const isFinance = _.get( this.props, "user.groups", [] )
      .find( group => group === "Finance" )

    const editExpenseFn = this.editExpense( expense.id )
    let _onClick = isFinance
      ? editExpenseFn
      : ( expense.billingPhase === "OnGoing" ? editExpenseFn : undefined )

    return {
      documentNumber: expense.documentNumber,
      expenseType: expense.expenseType,
      value: utils.formatCurrency( expense.value ),
      details: expense.details,
      expenseDate: utils.formatDate( expense.expenseDate ),
      internalInvoiceNumber: expense.internalInvoiceNumber,
      internalInvoiceDate: utils.formatDate( expense.internalInvoiceDate ),
      _onClick,
    }
  } )

  findExpense = id => {
    const expense = _.find( this.props.expenses, { id } )
    if ( !expense ) {
      return expense
    }

    if ( expense.receiptFileName ) {
      return {
        ...expense,
        receipt: {
          name: expense.receiptFileName,
        },
      }
    }

    return expense

  }

  render () {
    return (
      <Hidable title={strings.generalStrings.expenses} >
        <Card>
          <SimpleTable
            columns={TABLE_COLUMNS}
            data={this.prepareExpenses( this.props.expenses )}
          />
          <div className={styles.buttonRow}>
            <Button
              onClick={() => this.setState( {
                createFormVisible: true,
              } )}
              icon="add"
              raised
              primary
            >
              {strings.expenses.addExpense}
            </Button>
            <ExpenseDialog
              visible={this.state.createFormVisible}
              onSubmit={this.createExpense}
              onCancel={this.hideForms}
            />
            <ExpenseDialog
              edit
              expense={this.findExpense( this.state.editingExpense )}
              visible={this.state.editingExpense !== undefined}
              onCancel={this.hideForms}
              onSubmit={this.updateExpense}
              onDelete={this.deleteExpense}
              onDocumentDownload={this.downloadExpenseDocument}
            />
          </div>
        </Card>
      </Hidable>
    )
  }
}

export default connect( state => _.pick( state, [ "user" ] ) )( withActions( DebtPhaseExpenses ) )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseExpenses/index.jsx